import { xcss } from '@atlaskit/primitives/xcss/xcss';
import type { Options } from '@atlassiansox/cross-flow-support/cross-flow-api-internals';
import { CrossflowCtaSecondaryPressable } from '@post-office/components--crossflow-cta-button';
import { type FunctionComponent } from 'react';
// @ts-expect-error: 'React' is declared but its value is never read
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { type App } from '../../types';

const JOURNEY = 'decide';
const SOURCE_COMPONENT = 'jira-your-work';
const SOURCE_CONTEXT = 'learnMore';

const learnMoreButtonText = (
	<FormattedMessage
		id="post-office.jira-your-work-first-party-recommendation.learn-more"
		defaultMessage="Learn more"
		description={`CTA button text to learn more about the product for the Jira Your Work first party recommendation`}
	/>
);

const style = xcss({
	color: 'color.text',
	fontSize: '14px',
	backgroundColor: 'color.background.input',
	paddingInline: 'space.150',
	minHeight: '32px',
});

export const LearnMoreButton: FunctionComponent<{ app: App }> = ({ app }) => {
	const { formatMessage } = useIntl();

	const headerImageAltText = formatMessage(
		{
			id: 'post-office.jira-your-work-first-party-recommendation.learn-more.alt-text',
			defaultMessage: 'Discover more about {product}',
			description:
				'CTA button text to learn more about the product for the Jira Your Work first party recommendation',
		},
		{
			product: app.product,
		},
	);

	const crossflowOptions: Options = {
		targetProduct: app.hamsIdentifier,
		journey: JOURNEY,
		sourceComponent: SOURCE_COMPONENT,
		sourceContext: SOURCE_CONTEXT,
	};

	return (
		<CrossflowCtaSecondaryPressable
			crossflowOptions={crossflowOptions}
			ctaText={learnMoreButtonText}
			pressableStyle={style}
			alt={headerImageAltText}
		/>
	);
};
